import PropTypes from 'prop-types';

export const OptionType = PropTypes.shape(
    {
        label: PropTypes.any,
        value: PropTypes.any
    })
export const OptionsType = PropTypes.arrayOf(OptionType);


// WEBPACK FOOTER //
// ./src/scripts/types.js